<template>
  <div>
    <el-dialog
        title="Add Tag"
        :visible.sync="showAddTag">

      <p>Are you sure you want to <strong>add a tag?</strong></p>
      <p>If possible, consider using an existing tag.</p>
      <el-input placeholder="New tag" v-model="newTagValue"></el-input>
      <el-button v-on:click="addTag()" type="danger">Yes, really add this tag.</el-button>
      <el-button v-on:click="hideAddTag()" type="success">Actually, do not add this tag.</el-button>

    </el-dialog>
    <el-row style="margin-bottom: 25px;">
      <h1 style="display:inline;margin-right:10px">Annotation</h1>
      <span>for <strong>{{url}}</strong>, saved to <strong>{{extent_name}}</strong></span>
    </el-row>
    <el-row style="margin-bottom:15px;">
      <el-col :span="8" style="padding-right: 10px;">
        <div height="30px;">Observation*</div>
        <el-input
            @input="onChange"
            type="textarea"
            v-model="annotation.observation"
            :autosize="{ minRows: 2, maxRows: 10}">
        </el-input>
      </el-col>
      <el-col :span="8" style="padding-right: 10px;">
        <div height="30px;">Hypothesis/Question/Action</div>
        <el-input
            @input="onChange"
            type="textarea"
            v-model="annotation.hypothesis"
            :autosize="{ minRows: 2, maxRows: 4}">
        </el-input>
      </el-col>
      <el-col :span="5">
        <div height="30px;">{{ save_state_text }}</div>
        <el-button v-on:click="save()">Save</el-button>
        <el-button v-if="annotation_processed_asset_id" @click="processed_asset_details(annotation.processed_asset_id)" icon="el-icon-aim"></el-button>
      </el-col>
    </el-row>
    <el-row>
      <div v-if="tags" style="margin-bottom:20px;">
        <el-tag
            v-for="tag in tags"
            :key="tag.name"
            :type="selected_tag_names && selected_tag_names.includes(tag.name) ? 'success' : 'info'"
            :effect="selected_tag_names && selected_tag_names.includes(tag.name) ? 'dark' : 'light'"
            size="mini"
            @click="select_tag(tag)"
            style="margin-right:5px;"
        >
          {{tag.name}} ({{tag.count}})
        </el-tag>
        <el-tag
            size="mini"
            @click="showAddTagNow"
        >
          Add New Tag
        </el-tag>
      </div>
    </el-row>

    <div v-if="error_text" style="background-color: darkred; color:white;padding:20px;margin-bottom:10px;">{{error_text}}</div>
    <div style="margin-bottom:15px;">
      <div v-if="this.screenshot_url">
        <a :href="url" target="_blank"><img width="100%" :src="this.screenshot_url" /></a>
      </div>
      <div v-else>
        {{screenshot_state_text}}
      </div>
    </div>
    <el-row style="margin-bottom:15px;">
      <el-col :span="21">
        <el-upload
            id="data_file"
            :on-success="afterSuccessfulUpload"
            :on-remove="afterRemove"
            action="/api/uploads">
          <el-button size="small" type="primary">Click to manually upload screenshot</el-button>
        </el-upload>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Annotation",
  props: ['url_prop','extent_id_prop','address_hash_prop','annotation_prop','extent_prop','tags_prop'],
  data() {
    return {
      annotation_processed_asset_id_from_screenshot: null,
      initial_existing_screenshot_request_done: false,
      awaiting_screenshot: false,
      screenshot_url: '',
      unsaved_changes: false,
      extent_name: "",

      url: null,
      extent_id: null,
      address_hash: null,
      annotation: {
        observation: '',
        hypothesis: ''
      },
      extent: null,
      tags: [],
      selected_tag_names: [],
      showAddTag: false,
      newTagValue: '',

      error_text: '',
    }
  },
  mounted() {
    if (this.annotation_prop) {
        this.load_annotation_prop()
    } else {
      this.url = this.url_prop
      this.extent_id = this.extent_id_prop
      this.address_hash = this.address_hash_prop
      this.get()
      this.selected_tag_names = this.tag_names_only(this.annotation.tags) // This is a problem line
      this.get_screenshots()
    }

    if (this.tags_prop) {
      this.tags = this.tags_prop
    } else {
      axios.get('/annotations/tags_list/' + this.extent_id)
          .then(response => {
            this.tags = response.data
            console.log('tags')
          }).catch(error => {
          console.log('oops getting tags')
          this.tags = []
      })
    }

    axios.get('/extents/' + this.extent_id)
        .then(response => {
          this.extent_name = response.data.name
          console.log('got extent')
        }).catch(error => {
        console.log('oops getting extent name')
        this.extent_name = ""
    })
  },
  watch: {
    annotation_prop: function() {
      this.load_annotation_prop()
    },
  },
  computed: {
    annotation_processed_asset_id: function() {
      if (this.annotation.hasOwnProperty('id')) return this.annotation.processed_asset_id
      else return this.annotation_processed_asset_id_from_screenshot
    },
    screenshot_state_text: function() {
      if (this.screenshot_url) {
        return ""
      } else {
        if (this.awaiting_screenshot) {
          return "A new screenshot has been requested. We'll wait ten seconds. You can still make the annotation (even without the screenshot)."
        } else if (!this.initial_existing_screenshot_request_done) {
          return "Checking if screenshot already exists."
        } else {
          return "No screenshot. You can try refreshing this page."
        }
      }
    },
    // "Loaded existing annotation"
    // "Unsaved changes to existing annotation"
    // "Brand new annotation. Unsaved."
    save_state_text: function() {
      if (this.annotation.id) {
        if (this.unsaved_changes) {
          return "Unsaved changes to existing annotation."
        } else {
          return "Saved annotation."
        }
      } else {
        return "Brand new annotation. Unsaved."
      }
    }
  },
  methods: {
    processed_asset_details(processed_asset_id) {
      window.open("/assetdetails/" + this.extent_id + "/" + this.annotation_processed_asset_id,"_blank")
    },
    addTag() {
      this.selected_tag_names.push(this.newTagValue)
      this.tags.push({name:this.newTagValue,count:'new'})
      this.unsaved_changes = true
      this.showAddTag = false
    },
    hideAddTag() {
      this.showAddTag = false
    },
    showAddTagNow() {
      this.showAddTag = true
    },
    select_tag(tag) {
      this.unsaved_changes = true
      if (this.selected_tag_names && this.selected_tag_names.includes(tag.name)) {
        for(let i = 0; i < this.selected_tag_names.length; i++){
          if ( this.selected_tag_names[i] === tag.name) {
            this.selected_tag_names.splice(i, 1);
          }
        }
      } else {
        this.selected_tag_names.push(tag.name)
      }
    },
    tag_names_only(tags_full) {
      let tag_names = []
      if (tags_full) {
        tags_full.forEach(tag => {
          tag_names.push(tag.name.en)
        })
      }
      return tag_names
    },
    load_annotation_prop: function() {
      if (this.annotation_prop) {
        this.annotation = this.annotation_prop
        this.url = this.annotation.url
        this.extent_id = this.annotation.extent_id
        this.address_hash = this.annotation.address_hash
        if (this.annotation.screenshots) {
          let last_screenshot = this.annotation.screenshots[0]
          this.screenshot_url = last_screenshot.public_url
          this.initial_existing_screenshot_request_done = true
        } else {
          this.get_screenshots()
        }

        this.selected_tag_names = this.tag_names_only(this.annotation.tags)
      }
    },
    onChange() {
      this.unsaved_changes = true
      console.log('form change')
    },
    save() {
      this.annotation.url = this.url
      axios.post('/annotations/' + this.extent_id + '/' + this.address_hash, {
        annotation: this.annotation,
        tags: this.selected_tag_names
      }).then(response => {
        this.annotation = response.data
        this.unsaved_changes = false
        this.error_text = ''
        console.log('posted annotation')
      }).catch(error => {
        this.error_text = error.response.data
        console.log('oops saving annotation')
        console.log(error.response)
      })
      //
    },
    get(pass = 0) {
      axios.get('/annotations/' + this.extent_id + '/' + this.address_hash)
          .then(response => {
            this.annotation = response.data
            this.selected_tag_names = this.tag_names_only(this.annotation.tags)
            console.log('got annotation')
            this.unsaved_changes = false
      }).catch(error => {
        this.annotation = {
          observation: '',
          hypothesis: ''
        }
        console.log('oops getting annotation')
        console.log(error.response)
      })
      //
    },
    get_screenshots(pass = 0) {
      axios.get('/api/screenshots/' + this.extent_id + '/' + this.address_hash)
          .then(response => {
            this.screenshot_url = response.data.screenshots[0].public_url
            this.annotation_processed_asset_id_from_screenshot = response.data.processed_asset_id
            console.log('got screenshot')
            this.initial_existing_screenshot_request_done = true
          }).catch(error => {
            this.initial_existing_screenshot_request_done = true
            console.log('did not get screenshot')
            if (pass===0) {
              console.log('about to request ad hoc screenshot')
              this.screenshot_adhoc()
            }
        }
      )
    },
    screenshot_adhoc() {
      this.awaiting_screenshot = true
      console.log('in screenshot_adhoc')
      axios.post('/api/screenshot/adhoc/' + this.extent_id, {
        address: this.url
      })
          .then(response => {
            console.log('added job to the queue')

            setTimeout(() => {
              console.log('going to now request metadata again')
              this.get_screenshots(1)
              this.awaiting_screenshot = false
            }, 10 * 1000); // 10 seconds
          })
          .catch(error => {
            this.awaiting_screenshot = false
            console.log('oops could not seem to post to do an ad hoc screenshot')
          })
    },
    afterSuccessfulUpload(response) {
      axios.post('/api/screenshot/upload/' + this.extent_id, {
        address: this.url,
        upload_file: response
      })
          .then(response => {
            this.get_screenshots()
            console.log('uploaded screenshot')

          })
          .catch(error => {
            console.log('could not upload screenshot')
          })
    },
    afterRemove() {
      // noop
    }
  }
}
</script>

<style scoped>

</style>